import { render, staticRenderFns } from "./EmployeeLeaveAllowances.vue?vue&type=template&id=2e72ab34&scoped=true"
import script from "./EmployeeLeaveAllowances.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveAllowances.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLeaveAllowances.vue?vue&type=style&index=0&id=2e72ab34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72ab34",
  null
  
)

export default component.exports